import { useMutation, useQuery } from "urql";
import { User, UserUpsertInput } from "gql/graphql";

const GetUserQuery = /* GraphQL */ `
  query GetUser {
    getUser {
      id
      email
      first_name
      last_name
      company_name
      department_name
      division_name
      created_at
      updated_at
    }
  }
`;

export const useGetUser = () => {
  const [result, executeQuery] = useQuery({ query: GetUserQuery, pause: true });
  return {
    data: result.data,
    fetching: result.fetching,
    error: result.error,
    fetchUser: executeQuery
  };
}

const SignalAuthorizationQuery = /* GraphQL */ `
  query {
    getSignalAuthorization {
      user_id
      signal_group_id
      signal_group_member_id
      member_type
      email
      first_name
      last_name
      service_agreement
      created_at
      updated_at
    }
  }
`;

export const useGetSignalAuthorization = () => {
  const [result, executeQuery] = useQuery({ query: SignalAuthorizationQuery, pause: true });
  return {
    data: result.data,
    fetching: result.fetching,
    error: result.error,
    fetchSignalAuthorization: executeQuery
  };
}

export const useGetAcceptDate = () => {
  const [result, executeQuery] = useQuery({
    query: /* GraphQL */`
      query getAcceptDate {
        getAccountData {
          termsAcceptDate
        }

        getTerms {
          content
          contentEn
          button
          buttonEn
          updateDate
        }
      }
    `,
    pause: true,
  });

  return {
    data: result.data,
    fetching: result.fetching,
    error: result.error,
    fetchAcceptDate: executeQuery
  };
}

export const useSaveUser = () => {
  const [_, saveUser] = useMutation<{ saveUser: User }, { data: UserUpsertInput }>(
    `
      mutation SaveUser($data: UserUpsertInput!) {
        saveUser(data: $data) {
          id
          email
          first_name
          last_name
          company_name
          department_name
          division_name
          created_at
          updated_at
        }
      }
    `
  );

  return { saveUser };
};
